import React, { useCallback, useEffect, useState } from 'react';
import { useParams, useRouteMatch } from 'react-router-dom';
import LoginDetails from './SubComponents/LoginDetails';
import SpaceDetails from './SubComponents/SpaceDetails';
import {
  ADDONS,
  AGREEMENT,
  AMENITIES,
  COMMISSION,
  CONGRATULATIONS,
  DEFAULT_DATA_OBJ,
  EXTERNAL_SYSTEM,
  LOGIN_DETAILS,
  ORGANIZATION_DETAILS,
  PAYOUT_DETAILS,
  PRICING_OPTIONS,
  RULES,
  SAVINGS,
  CALENDARSYNC,
  SEATING_AND_COMMON,
  SEATING_ARRANGEMENT,
  SINGAPORE_SHORT_CODE,
  AUSTRALIA_SHORT_CODE,
  SPACE_AND_NOTICE,
  SPACE_DETAILS,
  SPACE_LOCATION,
  SRI_LANKA_SHORT_CODE,
  TAX_INFORMATION,
  UPLOADING_IMAGES,
  WELCOME,
} from './SpaceListingConstants';
import ExternalSystem from './SubComponents/ExternalSystems';
import UploadImages from './SubComponents/UploadImages';
import { Icon } from 'antd';
import SpaceAndNotice from './SubComponents/SpaceAndNotice';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAddOns,
  getAmenities,
  getCancellationPolicyDetails,
  getCategoriesAndActivityTypes,
  getCountryWiseEventType,
  getMrtStations,
  getPackageTypes,
  getPricingOptions,
  getRules,
  getSavings,
  getSeatingArrangements,
  getTaxDetails,
} from './ListingAction';
import TaxInformation from './SubComponents/TaxAndDetails';
import SeatingAndCommon from './SubComponents/SeatingAndCommon';
import Amenities from './SubComponents/Amenities';
import AddOns from './SubComponents/AddOns';
import Rules from './SubComponents/Rules';
import CalendarSync from './SubComponents/CalendarSync';
import PayoutDetails from './SubComponents/PayoutDetails';
import Commission from './SubComponents/Commission';
import Congratulations from './SubComponents/Congratulations';
import { googleMapAPIKey } from '../../settings';
import ListingMap from './Common/ListingMap';
import ListingStepper from './Common/ListingStepper';
import PricingOptions from './SubComponents/PricingOptions/PricingOptions';
import { Redirect, Route, Switch } from 'react-router';
import { useLocation } from 'react-router-dom';
import SpaceLocation from './SubComponents/SpaceLocation';
import { getProfileData, setProfileData, getNextListingRoute, getListingStepSlug } from './Common/DataController';
import { spaceListingData } from './Common/ProfileListingDataModal';
import { push } from 'connected-react-router';
import WelcomePage from './SubComponents/Welcome';
import OrganizationDetails from './SubComponents/OrganizationDetails';
import Agreement from './SubComponents/HostAgreement';
import SeatingArrangement from './SubComponents/SeatingArrangement';

const mapLoadingElement = <div style={{ height: '100%' }} />;
const mapContainerElement = <div className="container-element" style={{ height: '100%', minHeight: '380px' }} />;
const mapMapElement = <div className="map-element" style={{ height: '100%' }} />;

const SpaceListing = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [nearLocationLatitude, setNearlocationLatitude] = useState(0);
  const [nearLocationLongitude, setNearlocationLongitude] = useState(0);
  const seating_arrangement = useSelector((state) => state?.spaceListing?.seatingArrangement);
  const savings = useSelector((state) => state?.spaceListing?.savings);
  const amenities = useSelector((state) => state?.spaceListing?.amenities);
  const rules = useSelector((state) => state?.spaceListing?.rules);
  const addons = useSelector((state) => state?.spaceListing?.addons);
  const authDetails = useSelector((state) => state?.auth?.loginDetails?.data?.token || null);
  const searchURLstring = useSelector((state) => state?.router?.location?.search || '');
  const countryShortCode = useSelector((state) => state?.locationMeta?.data?.country_shortCode);
  const { url } = useRouteMatch();
  const { country } = useParams();
  const baseRouteURL = `${url}/`;
  // const [mainDataObj,setMainDataObj] = useState(getProfileData()?.[DEFAULT_DATA_OBJ] ? getProfileData():spaceListingData);
  // Resetting the data on main component loading!
  const [mainDataObj, setMainDataObj] = useState(spaceListingData(country));

  const handleMapSet = (value) => {
    setMainDataObj(value);
  };


  useEffect(() => {
    const pathname = window.location.pathname;
    const stepSlug = getListingStepSlug(pathname);
    const isOnListingRoot = pathname.includes('/list-a-space') && (!stepSlug || stepSlug === 'list-a-space');
    const isOnKnownListingStep = Boolean(stepSlug && stepSlug !== 'list-a-space');

    // Only force Welcome when landing on the bare list-a-space root.
    // Remounts mid-flow must not bounce users back to Welcome.
    if (isOnListingRoot && !isOnKnownListingStep) {
      dispatch(push(`${url}/${WELCOME}`));
    }

    // Seed session when empty, or reset when the URL market no longer matches the draft.
    const existing = getProfileData();
    const expectedCountry = spaceListingData(country)?.space_location?.[0]?.spaceCountry;
    const draftCountry = existing?.space_location?.[0]?.spaceCountry || existing?.organization_details?.[0]?.country;
    const marketMismatch = existing?.routeList?.length && expectedCountry && draftCountry && draftCountry !== expectedCountry;

    if (!existing?.routeList?.length || marketMismatch) {
      const fresh = spaceListingData(country);
      setProfileData(fresh);
      setMainDataObj(fresh);
    }

    dispatch(getCategoriesAndActivityTypes());
    dispatch(getPricingOptions(countryShortCode === 'AUS' ? AUSTRALIA_SHORT_CODE : SINGAPORE_SHORT_CODE));
    dispatch(getCancellationPolicyDetails());
    dispatch(getCountryWiseEventType(countryShortCode === 'AUS' ? AUSTRALIA_SHORT_CODE : countryShortCode === 'SG' ? SINGAPORE_SHORT_CODE : SRI_LANKA_SHORT_CODE));
    if (mainDataObj?.tax_information?.[0]?.LKR.length === 0) {
      dispatch(getTaxDetails(SRI_LANKA_SHORT_CODE));
    }
    if (mainDataObj?.tax_information?.[0]?.SGD.length === 0) {
      dispatch(getTaxDetails(countryShortCode === 'AUS' ? AUSTRALIA_SHORT_CODE : SINGAPORE_SHORT_CODE));
    }
    if (mainDataObj?.savings?.[0]?.data.length === 0) {
      dispatch(getSavings());
    }
    if (mainDataObj?.seating_arrangement?.[0]?.data.length === 0) {
      dispatch(getSeatingArrangements());
    }
    if (mainDataObj?.amenities?.[0]?.data.length === 0) {
      dispatch(getAmenities(countryShortCode === 'AUS' ? AUSTRALIA_SHORT_CODE : SINGAPORE_SHORT_CODE));
    }
    if (mainDataObj?.addons?.[0]?.data.length === 0) {
      dispatch(getAddOns());
    }
    if (mainDataObj?.rules?.[0]?.data.length === 0) {
      dispatch(getRules(countryShortCode === 'AUS' ? AUSTRALIA_SHORT_CODE : SINGAPORE_SHORT_CODE));
    }
    if (countryShortCode === 'SG') dispatch(getMrtStations());
    dispatch(getPackageTypes());
  }, []);

  useEffect(() => {
    if (authDetails && window.location.pathname.includes('list-a-space/welcome') && sessionStorage.getItem('nextClick') === 'true') {
      const nextRoute = getNextListingRoute(window.location.pathname);
      if (nextRoute) {
        dispatch(push(nextRoute));
      }
      sessionStorage.setItem('nextClick', false);
    }
  }, [authDetails]);

  useEffect(() => {
    if (savings && savings.length > 0) {
      handleSpaceLocation(
        SAVINGS,
        'data',
        savings.map((value) => {
          return { ...value, selectedStatus: false, capacity: 0 };
        })
      );
    }
  }, [savings]);

  useEffect(() => {
    if (seating_arrangement && seating_arrangement.length > 0) {
      handleSpaceLocation(
        SEATING_ARRANGEMENT,
        'data',
        seating_arrangement.map((value) => {
          return { ...value, selectedStatus: false, capacity: 0 };
        })
      );
    }
  }, [seating_arrangement]);

  useEffect(() => {
    if (amenities && amenities.length > 0) {
      handleSpaceLocation(
        AMENITIES,
        'data',
        amenities.map((value) => {
          return { ...value, selectedStatus: false };
        })
      );
    }
  }, [amenities]);

  useEffect(() => {
    if (addons && addons.length > 0) {
      handleSpaceLocation(
        ADDONS,
        'data',
        addons.map((value) => {
          return { ...value, price: 0, description: '', selectedStatus: false };
        })
      );
    }
  }, [addons]);

  useEffect(() => {
    if (rules && rules.length > 0) {
      handleSpaceLocation(
        RULES,
        'data',
        rules.map((value) => {
          return { ...value, selectedStatus: false };
        })
      );
    }
  }, [rules]);

  const handleSpaceLocation = useCallback((type, name, newValue) => {
    const tempObj = Object.assign({}, getProfileData(), {
      ...getProfileData(),
      processStarted: true,
      [type]: getProfileData()?.[type]?.map((value, index) => {
        value[name] = newValue;
        return value;
      }),
    });
    setMainDataObj(tempObj);
    setProfileData(tempObj);
  }, []);

  const handleNearestlocation =  (latitude,longitude) => {
  
     setNearlocationLatitude(latitude);
   setNearlocationLongitude(longitude);
   
  };


  // useEffect(()=>{
  //   if( window.location.pathname.includes("Singapore")){
  //     dispatch(push("/all/dashboard/list-a-space/welcome"))
  //   }
  // },[window.location.pathname])



  return (
    <>
      <div className="space-listing-page sl-revamp">
        <div className="sl-layout-wrapper">
          {/* Left: Vertical Step Sidebar */}
          <ListingStepper />

          {/* Right: Scrollable Content + Map Area */}
          <div className={`sl-content-area${location.pathname === baseRouteURL + SPACE_LOCATION ? ' sl-content-area--location' : ''}`}>
            {location.pathname !== baseRouteURL + SPACE_LOCATION ? (
              <div className="sl-content-inner">
                <Switch>
                  <Route
                    path={baseRouteURL + WELCOME}
                    component={() => <WelcomePage currentBlock={WELCOME} authDetails={authDetails} />}
                  />
                  <Route path={baseRouteURL + LOGIN_DETAILS} component={() => <LoginDetails currentBlock={LOGIN_DETAILS} />} />
                  <Route path={baseRouteURL + ORGANIZATION_DETAILS} component={() => <OrganizationDetails currentBlock={ORGANIZATION_DETAILS} />} />
                  <Route path={baseRouteURL + SPACE_DETAILS} component={() => <SpaceDetails currentBlock={SPACE_DETAILS} />} />
                  <Route path={baseRouteURL + EXTERNAL_SYSTEM} component={() => <ExternalSystem currentBlock={EXTERNAL_SYSTEM} />} />
                  <Route path={baseRouteURL + UPLOADING_IMAGES} component={() => <UploadImages currentBlock={UPLOADING_IMAGES} />} />
                  <Route path={baseRouteURL + SPACE_AND_NOTICE} component={() => <SpaceAndNotice currentBlock={SPACE_AND_NOTICE} />} />
                  <Route path={baseRouteURL + TAX_INFORMATION} component={() => <TaxInformation currentBlock={TAX_INFORMATION} />} />
                  <Route path={baseRouteURL + SEATING_AND_COMMON}>
                    <SeatingAndCommon currentBlock={SEATING_AND_COMMON} />
                  </Route>
                  <Route path={baseRouteURL + SEATING_ARRANGEMENT} component={() => <SeatingArrangement currentBlock={SEATING_ARRANGEMENT} />} />
                  <Route path={baseRouteURL + PRICING_OPTIONS} component={() => <PricingOptions />} />
                  <Route path={baseRouteURL + AMENITIES} component={() => <Amenities currentBlock={AMENITIES} />} />
                  <Route path={baseRouteURL + ADDONS} component={() => <AddOns currentBlock={ADDONS} />} />
                  <Route path={baseRouteURL + RULES} component={() => <Rules currentBlock={RULES} />} />
                  <Route path={baseRouteURL + PAYOUT_DETAILS} component={() => <PayoutDetails currentBlock={PAYOUT_DETAILS} />} />
                  <Route path={baseRouteURL + COMMISSION} component={() => <Commission currentBlock={COMMISSION} />} />
                  <Route path={baseRouteURL + CALENDARSYNC} component={() => <CalendarSync />} />
                  <Route path={baseRouteURL + AGREEMENT} component={() => <Agreement currentBlock={AGREEMENT} />} />
                  <Route path={baseRouteURL + CONGRATULATIONS} component={() => <Congratulations />} />
                  <Route path={'*'} component={() => <Redirect to={baseRouteURL + WELCOME} />} />
                </Switch>
              </div>
            ) : (
              /* Space Location: split view — form + map side by side in content area */
              <div className="sl-location-split">
                <div className="sl-location-form">
                  <SpaceLocation
                    currentBlock={SPACE_LOCATION}
                    handleMapSet={handleMapSet}
                    handleNearestlocation={handleNearestlocation}
                  />
                </div>
                <div className="sl-location-map">
                  <div className="map-title-wrapper">
                    <div className="map-title">Drag & drop the pin to your space location</div>
                  </div>
                  <ListingMap
                    isMarkerShown={true}
                    googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${googleMapAPIKey}&libraries=places`}
                    loadingElement={mapLoadingElement}
                    containerElement={mapContainerElement}
                    mapElement={mapMapElement}
                    locationDetails={getProfileData()?.[SPACE_LOCATION]?.[0]}
                    nearLatitude={nearLocationLatitude}
                    nearLongitude={nearLocationLongitude}
                    country={country}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SpaceListing;
